import { createSlice } from '@reduxjs/toolkit';

export const loadingSlice = createSlice({
	name: 'loading',
	initialState: { loading: false },
	reducers: {
		setLoading: (state, action) => ({ ...state, ...action.payload }),
		stopLoading: () => ({ loading: false }),
		startLoading: () => ({ loading: true }),
	},
});

export const { setLoading, stopLoading, startLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
